"use strict";
// Import flatpickr
import flatpickr from "flatpickr";
import 'flatpickr/dist/flatpickr.css';
import "flatpickr/dist/l10n/cs.js";
import { Ajax } from "./helpers";
class Search {
    constructor() {
        this.parameters = {
            selectCoverClass: '.fn_select',
            selectAnchorClass: '.form-control',
            selectListClass: '.c_search__box__list',
            selectOpenClass: 'selectOpen',
            selectCheckedClass: 'selectChecked',
            selectVal: 'c_search__box__val',
            selectInputVal: 'c_search__box__input__in',
            selectFirstItem: '.c_search__box__first',
            chooseBtn: '.fn_chooseBtn'
        };
    }
    _initElement(element, fn) {
        const className = element.startsWith('.') ? element.substring(1) : element;
        const selectElems = document.getElementsByClassName(className);
        if (selectElems.length === 0)
            return;
        if (typeof fn === "function") {
            for (const selectElem of selectElems) {
                this._eventListener(selectElem, fn);
            }
        }
    }
    _eventListener(element, fn) {
        element.addEventListener('click', fn, true);
        element.addEventListener('touch', fn, true);
    }
    _removeClasses(elements, className) {
        if (elements.length === 0)
            return;
        for (const element of elements) {
            element.classList.remove(className);
        }
    }
    _clearHeader(target) {
        const label = target.closest('label');
        const listElement = target.closest(this.parameters.selectListClass);
        if (!listElement) {
            console.error("Error: List element not found.");
            return;
        }
        const checkedItems = Array.from(listElement.getElementsByClassName(this.parameters.selectCheckedClass));
        if (checkedItems.length > 0) {
            for (const checkedItem of checkedItems) {
                const item = checkedItem;
                const elName = item.querySelector('input[type=checkbox]');
                if (elName && item) {
                    elName.removeAttribute('checked');
                    item.classList.remove(this.parameters.selectCheckedClass);
                }
            }
        }
        label === null || label === void 0 ? void 0 : label.classList.add(this.parameters.selectCheckedClass);
        this._resetHeader(target);
    }
    _resetHeader(target) {
        const closestElement = target.closest(this.parameters.selectCoverClass);
        const selectValElement = closestElement.getElementsByClassName(this.parameters.selectVal)[0];
        selectValElement.innerHTML = '';
        const selectInputValElement = closestElement.getElementsByClassName(this.parameters.selectInputVal)[0];
        selectInputValElement.classList.remove('d-none');
    }
    selectOpenFn(e) {
        const openClasses = document.getElementsByClassName(this.parameters.selectOpenClass);
        const target = e.target;
        if (!target)
            return;
        const cover = target.closest(this.parameters.selectCoverClass);
        const anchor = target.closest(this.parameters.selectAnchorClass);
        if (anchor) {
            if (cover.classList.contains(this.parameters.selectOpenClass)) {
                cover.classList.remove(this.parameters.selectOpenClass);
            }
            else {
                this._removeClasses(openClasses, this.parameters.selectOpenClass);
                cover.classList.add(this.parameters.selectOpenClass);
            }
        }
    }
    loadSubcategories(dataId, target) {
        const ajax = new Ajax('GET');
        ajax.request('/ajax.php?subcountries=1&id_country=' + dataId, (responseData) => {
            var _a;
            if (responseData.result === 1) {
                const subcountryCover = document.getElementById('fn_subcountry');
                if (!subcountryCover) {
                    throw new Error('Error: Element with ID "fn_subcountry" not found');
                }
                subcountryCover.innerHTML = responseData.html;
                const listItems = subcountryCover.getElementsByTagName('li');
                if (listItems.length > 1) {
                    this._removeClasses(document.getElementsByClassName(this.parameters.selectOpenClass), this.parameters.selectOpenClass);
                    const closestCover = subcountryCover.closest(`${this.parameters.selectCoverClass}`);
                    if (closestCover) {
                        closestCover.classList.add(this.parameters.selectOpenClass);
                    }
                    this._resetHeader(subcountryCover);
                }
                else {
                    (_a = target.closest(this.parameters.selectCoverClass)) === null || _a === void 0 ? void 0 : _a.classList.remove(this.parameters.selectOpenClass);
                }
            }
            else {
                throw new Error(responseData.message);
            }
        }, (error) => {
            console.error('Error:', error);
        });
    }
    loadSubcountries() {
        var _a;
        const checked = (_a = document.getElementById('fn_subcountry')) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(this.parameters.selectCheckedClass);
        if (checked) {
            for (const checkedItem of checked) {
                this.checkedItems(checkedItem, true);
            }
        }
    }
    selectCheckFn(e) {
        e.preventDefault();
        const target = e.target;
        const label = target.closest('label');
        if (!label)
            return;
        const input = label.querySelector('input[type="checkbox"]'), dataId = Number(label.getAttribute('data-id')), firstItem = target.closest(this.parameters.selectFirstItem), list = target.closest(this.parameters.selectListClass);
        if (!list)
            return;
        const firstItemLabel = list.querySelector(`${this.parameters.selectFirstItem} label`);
        if (!firstItem) {
            if (!dataId) {
                if (label.classList.contains(this.parameters.selectCheckedClass)) {
                    label.classList.remove(this.parameters.selectCheckedClass);
                    input.removeAttribute('checked');
                    if (!list.querySelector('input[type=checkbox]:checked')) {
                        firstItemLabel === null || firstItemLabel === void 0 ? void 0 : firstItemLabel.classList.add(this.parameters.selectCheckedClass);
                        this._resetHeader(target);
                    }
                    else {
                        this.checkedItems(target);
                    }
                }
                else {
                    label.classList.add(this.parameters.selectCheckedClass);
                    input.setAttribute('checked', 'checked');
                    firstItemLabel.classList.remove(this.parameters.selectCheckedClass);
                    this.checkedItems(target);
                }
            }
            else {
                if (dataId > 0) {
                    this._clearHeader(label);
                    this.loadSubcategories(dataId, target);
                    label.classList.add(this.parameters.selectCheckedClass);
                    input.setAttribute('checked', 'checked');
                    this.checkedItems(target);
                }
                else {
                    this._removeClasses(document.getElementsByClassName(this.parameters.selectOpenClass), this.parameters.selectOpenClass);
                    throw new Error('Country has ID 0!');
                }
            }
        }
        else {
            if (label.classList.contains(this.parameters.selectCheckedClass)) {
                this._removeClasses(document.getElementsByClassName(this.parameters.selectOpenClass), this.parameters.selectOpenClass);
            }
            else {
                this._clearHeader(label);
                this.checkedItems(target);
                this._removeClasses(document.getElementsByClassName(this.parameters.selectOpenClass), this.parameters.selectOpenClass);
            }
        }
    }
    checkedItems(target, loading = false) {
        var _a, _b;
        const list = target.closest(this.parameters.selectListClass);
        const checkedItems = Array.from((list === null || list === void 0 ? void 0 : list.getElementsByClassName(this.parameters.selectCheckedClass)) || []);
        const insertCover = (_a = target.closest(this.parameters.selectCoverClass)) === null || _a === void 0 ? void 0 : _a.getElementsByClassName(this.parameters.selectInputVal)[0];
        const val = (_b = target.closest(this.parameters.selectCoverClass)) === null || _b === void 0 ? void 0 : _b.getElementsByClassName(this.parameters.selectVal)[0];
        if (!list || !insertCover || !val)
            return;
        const values = checkedItems.map((item) => {
            const span = item.querySelector('span');
            return span ? span.innerHTML : '';
        }).filter(Boolean).join(', ');
        if (insertCover.className !== 'd-none') {
            if (values !== 'Nerozhoduje') {
                insertCover.classList.add('d-none');
                val.innerHTML = values;
            }
        }
        else {
            val.innerHTML = values;
        }
    }
    chooseBtnFn(e) {
        var _a;
        (_a = e.target.closest(this.parameters.selectCoverClass)) === null || _a === void 0 ? void 0 : _a.classList.remove(this.parameters.selectOpenClass);
    }
    bodyClickFn(e) {
        if (e.target.closest(this.parameters.selectCoverClass) == null) {
            this._removeClasses(document.getElementsByClassName(this.parameters.selectOpenClass), this.parameters.selectOpenClass);
        }
    }
    initSearch() {
        this._initElement(this.parameters.selectCoverClass, this.selectOpenFn.bind(this));
        this._initElement(this.parameters.selectListClass, this.selectCheckFn.bind(this));
        this._initElement(this.parameters.chooseBtn, this.chooseBtnFn.bind(this));
        this.bodyClick();
    }
    bodyClick() {
        this._eventListener(document.body, this.bodyClickFn.bind(this));
    }
    initFlatpickr() {
        const countFlat = document.getElementsByClassName('fn_datepicker').length;
        if (countFlat > 0) {
            flatpickr('.fn_datepicker', {
                locale: 'cs',
                altInput: true,
                minDate: "today",
                altFormat: "j.n.Y",
                dateFormat: "j.n.Y",
                wrap: true,
                mode: "range"
            });
        }
    }
}
document.addEventListener('DOMContentLoaded', function () {
    const search = new Search();
    search.initSearch();
    if (document.getElementById('fn_subcountry') !== null) {
        search.loadSubcountries();
    }
    search.initFlatpickr();
});
